export const avatarSize = {
  xxxl: 110,
  xxl: 100,
  xl: 90,
  lg: 80,
  md: 70,
  sm: 60,
  xs: 50,
  xxs: 40,
  xxxs: 30,
}

export const avatarType = {
  circle: 50,
  square: 5,
}
